// extracted by mini-css-extract-plugin
export default {"field":"ForgotPasswordForm_field__gwbRs","submitBtnContainer":"ForgotPasswordForm_submitBtnContainer__CPnLj","submitBtn":"ForgotPasswordForm_submitBtn__NhKgd"};